import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppointmentsNoShow } from 'app/interfaces/appointment.interface';
import {
	IChatMessageTemplate,
	IContactsInactive,
} from 'app/interfaces/contact.interface';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ProfessionalService {
	url = `${environment.servicesUrl}/professional`;

	constructor(private http: HttpClient) {}

	loadMessage(): Observable<{ message: string }> {
		return this.http.get<IChatMessageTemplate>(
			`${this.url}/chats/messages/templates?type=book-reminder`
		);
	}

	sendMessage(body: { userIds: string[]; message: string }): Observable<any> {
		return this.http.post(`${this.url}/chats/messages`, body);
	}

	public getContactsInactive(): Observable<IContactsInactive['contacts']> {
		return this.http.get<IContactsInactive['contacts']>(
			`${this.url}/contact/inactives`
		);
	}

	loadAppointmentsNoShow(contactId: string): Observable<IAppointmentsNoShow[]> {
		return this.http.get<IAppointmentsNoShow[]>(
			`${this.url}/appointments/no-show/contacts/${contactId}`
		);
	}
}
